import React from 'react';
import { styled, Card, Row, Col } from '@teko/ui';
import { ProductInfo } from '../../Common/ProductInfo/ProductInfo.es.js';
import { ProductPrice } from '../../Common/ProductPrice/ProductPrice.es.js';
import { Gift } from '../../Common/Gift/Gift.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = styled(Card)`
  padding: 1rem;
`;
const StyledProductPrice = styled(ProductPrice)`
  text-align: right;
  justify-content: flex-end;
`;
const StyledGift = styled(Gift)`
  margin: 0.5rem 0;
`;
const GiftBlock = styled.div`
  margin-left: 3rem;
`;
const CartLinePrint = (_a) => {
  var _b = _a, {
    product
  } = _b, props = __objRest(_b, [
    "product"
  ]);
  return /* @__PURE__ */ React.createElement(StyledCard, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    col: 7
  }, /* @__PURE__ */ React.createElement(ProductInfo, {
    product
  })), /* @__PURE__ */ React.createElement(Col, {
    col: 2.5
  }, /* @__PURE__ */ React.createElement("span", null, "x", product.quantity)), /* @__PURE__ */ React.createElement(Col, {
    col: 2.5
  }, /* @__PURE__ */ React.createElement(StyledProductPrice, {
    listedPrice: product.price,
    price: product.discountPrice
  }))), !!(product.gifts || []).length && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    col: 7
  }, /* @__PURE__ */ React.createElement(GiftBlock, null, product.gifts.map((gift, index) => /* @__PURE__ */ React.createElement(StyledGift, {
    key: index,
    image: {
      src: gift.imageUrl
    },
    text: gift.name
  }))))));
};

export { CartLinePrint };
